import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { Panel, ScreenFrame } from '../../ui/index.ts';
import styles from './Account.module.css';
import { Page, useAccountSession } from './common.tsx';

const GIVE_UP_MS = 10_000;

/** Where a provider or an e-mail link brings the player back to; the service reads the address, this just waits for the result. */
export function AuthCallback() {
  const { t } = useTranslation('account');
  const navigate = useNavigate();
  const { available, load, snapshot } = useAccountSession();
  const [late, setLate] = useState(false);

  // The service reports a refusal in the address (`error=access_denied`…), after `?` or `#`.
  const refused = (() => {
    const joined = `${location.search}&${location.hash.replace(/^#/, '')}`;
    return (
      new URLSearchParams(joined).has('error') || new URLSearchParams(joined).has('error_code')
    );
  })();

  useEffect(() => {
    if (load === 'ready' && snapshot.status === 'signedIn') {
      void navigate('/account', { replace: true });
    }
  }, [load, snapshot.status, navigate]);

  useEffect(() => {
    const id = setTimeout(() => {
      setLate(true);
    }, GIVE_UP_MS);
    return () => {
      clearTimeout(id);
    };
  }, []);

  const failed = refused || late || load === 'failed' || !available;
  return (
    <ScreenFrame title={t('callback.title')} backTo="/account">
      <Page>
        <Panel>
          {failed ? (
            <div className={styles['stack']}>
              <p className={styles['error']} role="alert">
                {t('callback.failed')}
              </p>
              <Link className={styles['link']} to="/account">
                {t('callback.home')}
              </Link>
            </div>
          ) : (
            <p className={styles['note']} role="status">
              {t('callback.body')}
            </p>
          )}
        </Panel>
      </Page>
    </ScreenFrame>
  );
}
